import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

class SubmitReportModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func,
      postValue: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
         }),
      ]),
      errorMsg: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      handleSubmit: (e) => {
         e.preventDefault();
         console.log('submitted');
      },
      postValue: {},
      errorMsg: '',
   };

   constructor(props) {
      super(props);
      this.state = {};
      this.isLoading = false;
      this.toggle = this.toggle.bind(this);
   }

   toggle() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         toggle, modal, handleChange, handleSubmit, postValue, errorMsg,
      } = this.props;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header"
            >
               <div className="modal__header bg_blue">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">Submit Report</h4>
               </div>
               <form onSubmit={handleSubmit} id="stocks_form">
                  <div className="modal__body p-t-10">
                  { errorMsg && (
                     <div className="notif_msg">
                        <Alert color="danger" className="alert--colored">
                        <div className="alert__content">
                           <p>{errorMsg}</p>
                        </div>
                        </Alert>
                     </div>
                     )
                  }
                  <div className="form form--vertical m-t-10">
                     <div className="form__form-group">
                        <span className="form__form-group-label">Actual Count <b className="text-danger m-l-5">*</b></span>
                        <div className="form__form-group-field">
                           <input type="text" name="actualCount" placeholder="Actual Count" value={postValue && postValue.actualCount ? postValue.actualCount : ''} onChange={e => handleChange(e, 'number')} />
                        </div>
                     </div>
                     <div className="form__form-group">
                        <span className="form__form-group-label">Note</span>
                        <div className="form__form-group-field">
                           <textarea name="note" placeholder="Note" className="mh-150 no-resize" value={postValue && postValue.note ? postValue.note : ''} onChange={e => handleChange(e)} />
                        </div>
                     </div>
                  </div>
                  </div>
                  <ButtonToolbar className="modal__footer">
                     <Button color="primary">Submit</Button>
                     <Button onClick={toggle}>Cancel</Button>
                  </ButtonToolbar>
               </form>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'stockForm',
})(withTranslation('common')(SubmitReportModal));
